const objContext = JSON.parse(sessionStorage.getItem("context"));
if(objContext == null || objContext.store_name == null)
    location.href='index.html';
var id_current_store = null, url_picture = null, objStoreInfo = null;
const   sectionTab = document.querySelectorAll('.sidebar-menu-container-section-tab'),
        btnSave = document.getElementById('btnSaveBanner'),
        ddlBannerType = document.getElementById('selectTypeBanner'),
        ddlBannerMenu = document.getElementById('selectMenuBanner');

document.querySelector('.sidebar-profile-user').innerText = localStorage.getItem('current_user') || '';

if(sectionTab != null)
    sectionTab[6].classList.add('sidebar-menu-container-section-tab--active');

let layoutCard = `
    <div class="banner-item">
        <div class="banner-item__image">
            <img src="{URL-IMG-BANNER}" alt="">
        </div>
        <div class="banner-item__info">
            <p class="title">{TITLE-BANNER}</p><br/>
            <p class="url">{URL-BANNER}</p>
        </div>
        <div class="banner-item__actions">
            <span class="icon-edit" onclick="editBanner(this);" data-id="{ID-BANNER}" data-type="{TYPE-BANNER}" data-content="{CONTENT-BANNER}" data-picture="{PICTURE-BANNER}"></span>
            <span class="icon-trash" onclick="deleteBanner(this);" data-id="{ID-BANNER}" data-url="{URL-BANNER}"></span>
        </div>
    </div>
`;

window.addEventListener("load", loadPage);
function loadPage(){
    id_current_store = localStorage.getItem("currentStore");

    if(id_current_store == null || objContext == null)
        location.href='index.html';
    else {
        document.querySelector('.sidebar-profile-img img').src = objContext.store_image
        document.querySelector('.sidebar-profile-name-store').innerHTML = objContext.store_name.replace(/\\/, '')
        //document.getElementById('img-store').src = objContext.store_image;
        //document.getElementById('name-store').innerText = objContext.store_name;
        //document.getElementById('breadcrumb-menu').innerText = objContext.menu_name;

        //loadBanners();
        //loadProducts();
        console.log(id_current_store);
        loadStoreInfo();
    }
}

function previewPicture(e){
    document.querySelector('.alerts-container').innerHTML = '';
    url_picture = null;

    let outPut = document.querySelector('.menu-product-img');
    outPut.innerHTML = "";
    let outPutImage = document.createElement("img");
    outPutImage.src = URL.createObjectURL(e.target.files[0]);

    outPutImage.onload = function() {
        URL.revokeObjectURL(outPutImage.src) // free memory

        if(this.width >= 500 && this.height >= 500){
            if(e.target.files[0].size < 4096000)
              outPut.appendChild(outPutImage);
            else{
              alert('Por favor, seleccione una imagen de menos de 4MB.', 'error');
              e.target.value = "";
            }
        }
        else{
            alert('Por favor, seleccione una imagen de al menos 500x500 pixeles.', 'error');
            e.target.value = "";
        }
    }
}

function loadStoreInfo(){
    UI.showLoader();

    fetch(
        BASE_URLS.Dinny.api + `/stores/${id_current_store}?req_id=${new Date().getTime()}`,
        {
          credentials: 'include'
        }
    ).then(function(response){
        if(response.ok){
            UI.hideLoader();
            ddlBannerMenu.innerHTML = '<option value="0" hidden="" selected="">Selecciona un menú</option>';

            response.json().then(function(json){
                console.log(json);
                objStoreInfo = json;

                if(objStoreInfo.menu && objStoreInfo.menu != null && objStoreInfo.menu.length > 0){
                    objStoreInfo.menu.forEach((element) => {
                        ddlBannerMenu.insertAdjacentHTML(
                            'beforeend',
                            `<option value='${element.id}'>${element.name}</option>`
                        )
                    });
                }else{
                    UI.message({ title: 'Datos incompletos', content: 'Para poder crear un banner es necesario que el establecimiento cuente al menos con un menú sincronizado con Dinny.<br/><br/>Por favor, crea un menú en tu administrador y sincronízalo con Dinny para que puedas agregar banners.', accept: 'Aceptar' }, function(){
                        location.href='index.html';
                    });
                    return;
                }

                let idMenu = sessionStorage.getItem('idmenu');
                if(idMenu != null && idMenu.length > 0){
                    ddlBannerMenu.value = idMenu;
                    ddlBannerMenu.dispatchEvent(new Event('change'));
                    sessionStorage.removeItem("idmenu");
                }

                // document.getElementById('selectMenuBanner').insertAdjacentHTML(
                //     'beforeend',
                //     `<option value='700'>Otro menú</option>`
                // )
            });
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                  window.location.href = 'login.html'
                }else{
                    UI.hideLoader();
                    alert("Ocurrió un error al cargar los banners.", 'error')
                }
            })
        }
    }).catch(function(){ UI.hideLoader() });
}

function loadBanners(menu_id){
    document.getElementById('bannerContainer').innerHTML = '';
    document.getElementById('div-banners-added').style = "display:none";

    if(objStoreInfo != null && objStoreInfo.menu != null && objStoreInfo.menu.length > 0){
        let objMenu = objStoreInfo.menu.find(x => x.id == menu_id);

        if(objMenu != null && objMenu.banners != null && objMenu.banners.length > 0){
            document.getElementById('div-banners-added').style = "display:grid";

            objMenu.banners.forEach((objBanner) => {
                document.getElementById('bannerContainer').insertAdjacentHTML(
                    'beforeend',
                    layoutCard
                        .replace(/{URL-IMG-BANNER}/ig, objBanner.image)
                        .replace(/{TITLE-BANNER}/ig, objBanner.type)
                        .replace(/{URL-BANNER}/ig, objBanner.url)
                        .replace(/{ID-BANNER}/ig, objBanner.id)
                        .replace(/{TYPE-BANNER}/ig, objBanner.type)
                        .replace(/{CONTENT-BANNER}/ig, objBanner.content)
                        .replace(/{PICTURE-BANNER}/ig, objBanner.image)
                );
            });
        }
    }
}

function loadProducts(menu_id){
    document.getElementById('selectProductBanner').innerHTML = '<option value="0" hidden="" selected="">Seleciona un producto</option>';

    if(objStoreInfo != null && objStoreInfo.menu != null && objStoreInfo.menu.length > 0){
        let objMenu = objStoreInfo.menu.find(x => x.id == menu_id);

        if(objMenu != null && objMenu.categories != null && objMenu.categories.length > 0){
            objMenu.categories.forEach((objCategory) => {
                if(objCategory.products != null && objCategory.products.length > 0){
                    objCategory.products.forEach((objProduct) => {
                        document.getElementById('selectProductBanner').insertAdjacentHTML(
                            'beforeend',
                            `<option value='${objProduct.id}'>${objProduct.name}</option>`
                        );
                    });
                }
            });
        }
    }
}

btnSave.addEventListener('click', function(e){
    document.querySelector('.alerts-container').innerHTML = '';
    let bannerMenu = document.getElementById('selectMenuBanner').value;
    let bannerType = document.getElementById('selectTypeBanner').value;
    let productId = document.getElementById('selectProductBanner').value;
    let bannerURL = document.getElementById('txtBannerURL').value.trim();
    let bannerImage = document.getElementById('banner-image').files[0];
    let isAdd = btnSave.innerText.toLowerCase() == "generar";

    if(bannerMenu == "0"){
        alert("Seleccione un menú.", 'error');
            return;
    }

    if(bannerType.length != 0){
        if(bannerType == "Producto" && productId == "0"){
            alert("Seleccione un producto.", 'error');
            return;
        }

        if(bannerType == "Link externo" && bannerURL.length == 0){
            alert("Escriba el link del banner.", 'error');
            return;
        }

        if(bannerType != "Producto" && !/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(bannerURL)){
            alert("El link del banner no es una URL válida.", 'error');
            return;
        }

        if(isAdd && (bannerImage == null || bannerImage === "undefined"))
        {
            alert('Seleccione una imagen para el banner.', 'error');
            return;
        }

        let objBanner = {
            id: isAdd ? "0" : btnSave.dataset.id,
            type: bannerType,
            is_active: true,
            store_id: id_current_store,
            menu_id: bannerMenu,
            product_id: productId,
            image: url_picture,
            url: bannerURL
          };

        UI.showLoader();

        if(bannerImage != null && bannerImage !== "undefined"){
            //Guardar imagen...
            let objReader = new FileReader();
            objReader.readAsDataURL(bannerImage);
            objReader.onload = function(e){
                let base64string = e.target.result;
                base64string = base64string.replace(base64string.substring(0, base64string.indexOf(',') + 1), "");

                fetch(
                    BASE_URLS.Standalone.api + '/picture',
                    {
                    method: 'POST',
                    body: JSON.stringify({
                        key: 'image/banners/' + new Date().toISOString().replace(/:/g, '').replace(/-/g, '').replace(/\./g, '') + '.' + bannerImage.name.split('.').pop(),
                        content: base64string,
                        contentType: bannerImage.type
                    }),
                    credentials: 'include'
                }).then(function(response){
                    if(response.ok){
                        response.json().then(function(picture_url){
                            objBanner.image = picture_url;

                            if(isAdd)
                                addBanner(objBanner);
                            else
                                updateBanner(objBanner);
                        });
                    }else{
                        response.json().then(function(content){
                            if(403 == response.status){
                                window.location.href = 'login.html'
                            }else{
                                UI.hideLoader();
                                alert('Ocurrió un error al guardar la imagen.', 'error');
                            }
                        });
                    }
                }).catch(function(e){
                    UI.hideLoader();
                    alert('Ocurrió un error al guardar la imagen.', 'error');
                    console.log(e);
                });
            };
        }
        else{
            updateBanner(objBanner);
        }
    }
    else{
        alert("Seleccione un tipo de banner.", 'error');
    }
});

ddlBannerMenu.addEventListener('change', function(e){
    document.querySelector('.alerts-container').innerHTML = '';
    let bannerMenu = this.value;

    if(bannerMenu != "0"){
        document.getElementById('banner-type').style = "display:flex";
        loadBanners(bannerMenu);

        document.getElementById('banner-product').style = "display:none";
        document.getElementById('banner-url').style = "display:none";
        document.getElementById('selectTypeBanner').value = "";
        loadProducts(bannerMenu);
    }
    else{
        document.getElementById('banner-type').style = "display:none";
    }
});

ddlBannerType.addEventListener('change', function(e){
    document.querySelector('.alerts-container').innerHTML = '';
    let bannerType = this.value;

    document.getElementById('selectProductBanner').value = "0";
    document.getElementById('txtBannerURL').value = "";

    if(bannerType == 'Producto'){
        //Check if cityId
        if(objStoreInfo.store.address.cityId == "0"){
            UI.message({ title: 'Datos incompletos', content: 'Para poder crear un banner de tipo "Producto" es necesario que completes la información de "Ubicación" en el "Perfil" del establecimiento.', accept: 'Aceptar' }, function(){
                document.getElementById('selectTypeBanner').value = "";
                document.getElementById('banner-url').style = "display:none";
            });
            return;
        }

        let menu_id = document.getElementById('selectMenuBanner').value;
        if(menu_id != "0"){

            let objMenu = objStoreInfo.menu.find(x => x.id == menu_id), hasProducts = false;

            if(objMenu.categories != null && objMenu.categories.length > 0){
                objMenu.categories.forEach((objCategory) => {
                    if(objCategory.products != null && objCategory.products.length > 0){
                        hasProducts=true;
                    }
                });
            }

            if(!hasProducts){
                UI.message({ title: 'Datos incompletos', content: 'Para poder crear un banner de tipo "Producto" es necesario que el menú seleccionado cuente al menos con un producto sincronizado con Dinny.', accept: 'Aceptar' }, function(){
                    document.getElementById('selectTypeBanner').value = "";
                    document.getElementById('banner-url').style = "display:none";
                });
                return;
            }
        }
        else{
            alert('Selecciona primero un menú', 'error');
            this.value = "";
        }
        document.getElementById('banner-product').style = "display:flex";
        document.getElementById('banner-url').style = "display:none";
    }else{
        document.getElementById('banner-url').style = "display:flex";
        document.getElementById('banner-product').style = "display:none";
    }
});

function addBanner(objBanner){
    fetch(
        BASE_URLS.Dinny.no_cms + '/banner',
        {
          method: 'POST',
          body: JSON.stringify(objBanner),
          credentials: 'include'
    }).then(function(response){
        if(response.ok){
            sessionStorage.setItem("idmenu", objBanner.menu_id);
            location.reload();
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                  window.location.href = 'login.html'
                }else{
                    UI.hideLoader();
                    alert('Ocurrió un error al guardar el banner.', 'error');
                }
              });
        }
    }).catch(function(e){
        UI.hideLoader();
        alert('Ocurrió un error al guardar el banner.', 'error');
        console.log(e);
    });
}

function editBanner(element){
    btnSave.dataset.id = element.dataset.id;
    document.getElementById('banner-url').style = "display:none";
    document.getElementById('banner-product').style = "display:none";
    document.getElementById('selectProductBanner').value = "0";
    document.getElementById('txtBannerURL').value = "";

    document.getElementById('selectTypeBanner').value = element.dataset.type;
    btnSave.innerText = "Guardar";
    url_picture = element.dataset.picture;

    if(element.dataset.type == "Producto"){
        document.getElementById('selectProductBanner').value = element.dataset.content;
        document.getElementById('banner-product').style = "display:flex";
    }
    else{
        document.getElementById('banner-url').style = "display:flex";
        document.getElementById('txtBannerURL').value = element.dataset.content;
    }
}

function updateBanner(objBanner){
    fetch(
        BASE_URLS.Dinny.no_cms + '/banner',
        {
          method: 'PUT',
          body: JSON.stringify(objBanner),
          credentials: 'include'
    }).then(function(response){
        if(response.ok){
            sessionStorage.setItem("idmenu", objBanner.menu_id);
            location.reload();
        }else{
            response.json().then(function(content){
                if(403 == response.status){
                  window.location.href = 'login.html'
                }else{
                    UI.hideLoader();
                    alert('Ocurrió un error al guardar el banner.', 'error');
                }
              });
        }
    }).catch(function(e){
        UI.hideLoader();
        alert('Ocurrió un error al guardar el banner.', 'error');
        console.log(e);
    });
}

function deleteBanner(element){
    UI.confirm({
        title: 'Eliminar banner',
        content: '¿Estás seguro de eliminar el banner con link ' + element.dataset.url + '?',
        cancel: 'No',
        accept: 'Sí'
    }, function(response){
      if(response){
        UI.showLoader();
        fetch(
          BASE_URLS.Dinny.no_cms + '/banner/' + element.dataset.id + '/?store_id=' + id_current_store + '&menu_id=' + document.getElementById('selectMenuBanner').value + '&req_id=' + new Date().getTime(),
          {
              method: 'DELETE',
              credentials: 'include'
          }
        ).then(function(response){
            if(response.ok){
                sessionStorage.setItem("idmenu", document.getElementById('selectMenuBanner').value);
                location.reload();
            }
            else{
              response.json().then(function(content){
                  if(403 == response.status){
                    window.location.href = 'login.html'
                  }else{
                    UI.hideLoader();
                    alert('Ocurrió un error al eliminar el banner.', 'error');
                  }
                });
            }
        }).catch(function(e){
          UI.hideLoader();
          console.log(e)
          alert('Ocurrió un error al eliminar el banner.', 'error');
        });
      }
    });
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}